import React, { useRef, useState } from "react"
import "./index.css"
import { onDownloadReportPdf } from "./DownloadReport"
import zithasLogo from "../../../../assets/images/zithas-dark-logo.png"
import coverImage from "../../../../assets/images/seo_cover_image.png"
import { Modal } from "reactstrap"

export default function SeoReportPreview({
  previewModal,
  setPreviewModal,
  reportSummary,
  challenges,
  highlights = [],
  ordersPerformance = {},
  campaigns = [{}],
  localSeoPerformance = [{}],
  keywordSummary,
  performanceComparison = [],
  nextSteps,
  month,
  year,
  project,
  monthOptions,
  allMonthKeywords = {},
  customerData = {},
  trafficImage,
  isOrders
}) {
  const [loading, setLoading] = useState(false)

  const reportRef = useRef() 

  // manage to show keyword with 20 per page limit
  const chunkSize = 20;

  const chunkedKeywordData = [];
  for (let i = 0; i < allMonthKeywords?.data?.length; i += chunkSize) {
    chunkedKeywordData.push(
      allMonthKeywords.data.slice(i, i + chunkSize)
    );
  }
  
  return (
    <>
      <Modal isOpen={previewModal} size="xl" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            SEO Report - {project?.label || ""}
          </h5>
          <div>
            <button
              onClick={() =>
                onDownloadReportPdf(setLoading, reportRef, "Seo_Report")
              }
              className="btn btn-success me-4"
              disabled={loading}
            >
              <i
                className={`fas fa-${loading ? "spinner bx-spin" : "download"
                  } me-2`}
              ></i>{" "}
              Download
            </button>
            <button
              type="button"
              onClick={() => {
                setPreviewModal(false)
              }}
              className="btn-modal-close"
            >
              <span className="btn-modal-span">&times;</span>
            </button>
          </div>
        </div>
        <div
          className="modal-body pt-0"
          style={{ maxHeight: "84vh", overflow: "auto" }}
        >
          <div ref={reportRef} className="custom-seoreport-preview pt-4">
            <div className="report-wrapper">
              {/* COVER PAGE */}
              <section className="report-page shadow-sm cover">
                <div className="row">
                  <div className="col-5 text-start">
                    <div className="company-logo mb-4 ">
                      <img src={zithasLogo} height={65} alt="zithas logo" />
                    </div>
                    <h1>
                      {" "}
                      {project?.services?.filter(item => item.value == "1")?.map(
                        (item, i) =>
                          `${item?.label} ${project?.services?.filter(item => item.value == "1").length - 1 !== i ? " & " : ""
                          }`
                      )}{" "}
                    </h1>
                    <h2 className="text-uppercase">Monthly Report</h2>
                    {/* {month && <h2>{`${monthOptions[month - 1]} ${year}`}</h2>} */}

                    <div className="cover-info">
                      <p className="client">
                        {customerData?.company || "Client Name"}
                      </p>
                      {month && (
                        <p className="badge fs-5 py-2 px-2 bg-warning text-purple">
                          Reporting Period:{" "}
                          {`${monthOptions[month - 1]} ${year}`}
                        </p>
                      )}
                      <p>
                        {" "}
                        <i className="fas fa-globe me-1"></i>{" "}
                        {customerData?.website || "www.example.com"}
                      </p>
                    </div>
                  </div>
                  <div className="col-7 text-end">
                    <div>
                      <img
                        src={coverImage}
                        className="w-100 "
                        alt="zithas logo"
                      />
                    </div>
                  </div>
                </div>
              </section>

              {/* REPORT SUMMARY */}
              <section className="report-page shadow-sm">
                <h3>Report Summary</h3>
                {/* <p className="paragraph">{data.reportSummary}</p> */}
                <p
                  className="paragraph ckeditor-content"
                  dangerouslySetInnerHTML={{ __html: reportSummary }}
                ></p>
              </section>

              {/* CHALLENGES */}
              <section className="report-page shadow-sm">
                <h3>Key Challenges & Areas for Improvement</h3>
                {/* <p className="paragraph">{data.challenges}</p> */}
                <p
                  className="paragraph ckeditor-content"
                  dangerouslySetInnerHTML={{ __html: challenges }}
                ></p>
              </section>

              {/* HIGHLIGHTS */}
              <section className="report-page shadow-sm">
                <h3>Key Highlights</h3>
                <ul className="highlight-list">
                  {highlights?.map((h, i) => (
                    <li key={i}>{h}</li>
                  ))}
                </ul>
              </section>

              {/* ORDERS PERFORMANCE */}
              {ordersPerformance && isOrders && (
                <section className="report-page shadow-sm">
                  <h3>Performance – Primary Goal: Orders</h3>

                  <div className="metric-grid">
                    {Object.values(ordersPerformance).map((o, i) => (
                      <div className="metric-card" key={i}>
                        <h4>{o.title}</h4>
                        <p className="metric-value">{o.value || 0}</p>
                        <span>{o.subtitle}</span>
                        {o.reason && (
                          <div className="alert alert-warning py-1 px-2 mt-2 mb-0">
                            {o.reason}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                </section>
              )}

              {/* CAMPAIGNS */}
              {(campaigns[0]?.title ||
                campaigns[0]?.description ||
                campaigns[0]?.link) && (
                  <>
                    {campaigns?.map((c, i) => (
                      <section className="report-page shadow-sm" key={i}>
                        <h3>Campaign Performance – {c.title}</h3>
                        <p className="paragraph">{c.description}</p>
                        <img src={c.link} className="full-image" alt={c.title} />
                      </section>
                    ))}
                  </>
                )}

              {/* LOCAL SEO */}
              {(localSeoPerformance &&
                (localSeoPerformance[0]?.google_buisness ||
                  localSeoPerformance[0]?.interactions ||
                  localSeoPerformance[0]?.calls ||
                  localSeoPerformance[0]?.directions ||
                  localSeoPerformance[0]?.Click)) && (
                  <>
                    {localSeoPerformance?.map((l, i) => (
                      <section className="report-page shadow-sm" key={i}>
                        <h3>Local SEO – {l.google_buisness}</h3>

                        <div className="local-grid">
                          <div>
                            Interactions <strong>{l.interactions}</strong>
                          </div>
                          <div>
                            Calls <strong>{l.calls}</strong>
                          </div>
                          <div>
                            Directions <strong>{l.directions}</strong>
                          </div>
                          <div>
                            Clicks <strong>{l.Click}</strong>
                          </div>
                        </div>
                        {/* <iframe
                        src={l.link}
                        width="600"
                        height="400"
                        style={{ border: "none" }}
                        title="onedrive-image"
                      /> */}

                        <img src={l.link} className="full-image" alt="" />
                      </section>
                    ))}
                  </>
                )}

              {/* KEYWORDS */}
              {/* <section className="report-page shadow-sm">
                <h3>Keyword Position Summary</h3>
                <p
                  className="paragraph"
                  dangerouslySetInnerHTML={{ __html: keywordSummary }}
                ></p>

                <table className="keyword-table">
                  <thead>
                    <tr>
                      <th>Keyword</th>
                      {allMonthKeywords?.columns?.map(col => (
                        <th key={col.key}>{col.label}</th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {allMonthKeywords?.data?.map((row, i) => (
                      <tr key={i}>
                        <td>{row.keyword}</td>

                        {allMonthKeywords?.columns?.map((col, i) => (
                          <td key={col.key}>
                            {row.months[col.key] ?? "--"}
                            {allMonthKeywords?.columns?.length - 1 === i && (
                              <i
                                // className={`fas fa-arrow-${row.progress} ${row.progress} ms-2`}
                                className={`fas fa-${["up", "down"].includes(row.progress) ? 'arrow-' : ''}${row.progress} ${row.progress} ms-2`}
                              ></i>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section> */}

              <section className="report-page shadow-sm">
                <h3>Keyword Position Summary</h3>
                <p
                  className="paragraph ckeditor-content"
                  dangerouslySetInnerHTML={{ __html: keywordSummary }}
                ></p>
              </section>

              {chunkedKeywordData?.map((chunk, sectionIndex) => (
                <section key={sectionIndex} className="report-page shadow-sm">
                  <h3>Keyword Rankings</h3>

                  <table className="keyword-table">
                    <thead>
                      <tr>
                        <th>Keyword</th>
                        {allMonthKeywords?.columns?.map(col => (
                          <th key={col.key}>{col.label}</th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {chunk?.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          <td>{row.keyword}</td>

                          {allMonthKeywords?.columns?.map((col, colIndex) => (
                            <td key={col.key}>
                              {row.months[col.key] ?? "--"}
                              {allMonthKeywords?.columns?.length - 1 === colIndex && (
                                <i
                                  className={`fas fa-${["up", "down"].includes(row.progress) ? "arrow-" : ""}${row.progress} ${row.progress} ms-2`}
                                ></i>
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </section>
              ))}

              {/* TRAFFIC */}
              <section className="report-page shadow-sm">
                <h3>Website Traffic Comparison</h3>

                <table className="traffic-table text-center">
                  <thead>
                    <tr>
                      <th className="text-start">Metric</th>
                      <th className="text-center">Current Month</th>
                      <th className="text-center">Last Month</th>
                      <th className="text-center">Change (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {performanceComparison?.map((r, i) => (
                      <tr key={i}>
                        <td className="text-start">{r.metric}</td>
                        <td>{r.current}</td>
                        <td>{r.last}</td>
                        <td>
                          {" "}
                          {r.trend == "up" ? "+" : "-"}
                          {r.percentage}%
                          <i
                            className={`fas fa-arrow-${r.trend} ${r.trend} ms-2`}
                          ></i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {
                  trafficImage &&
                  <img src={trafficImage} className="full-image" alt="" />
                }

              </section>

              {/* NEXT STEPS */}
              <section className="report-page shadow-sm">
                <h3>Next Steps & Strategies</h3>
                {/* <p className="paragraph">{data.nextSteps}</p> */}
                <p
                  className="paragraph ckeditor-content"
                  dangerouslySetInnerHTML={{ __html: nextSteps }}
                ></p>
              </section>

              <section className="report-page shadow-sm">
                <div className="text-center">
                  <div className="company-logo mb-5 ">
                    <img src={zithasLogo} height={75} alt="zithas logo" />
                  </div>
                  <h2 className="text-purple display-3 fw-bold text-uppercase mb-5">
                    Thank You
                  </h2>

                  <div className="fs-4">
                    <i className="fas fa-globe me-1"></i>{" "}
                    <a
                      href="https://www.zithas.com"
                      className="text-dark text-decoration-none"
                    >
                      https://www.zithas.com
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
